enum I9Constants {
  PROGRAM_NAME = 'E-Verify+',
  I9_INTRO_TEXT = 'E-Verify plus Form I-9 streamlines the employment eligibility verification process by having employees complete their Form I-9 directly through E-Verify.  This lessens your administrative burden and gives employees greater control over their personal information.',
  TRAINING_VIDEO_ID = 'Q78O9ZDJ8rI',
}

export default I9Constants;
